<template>
  <wsp-modal>
    <v-card class="pb-5" flat>
      <v-toolbar class="primary" dark dense flat>
        <v-toolbar-title>{{ $t('teletag.getTeletag.title') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="visible = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-container>
        <template v-if="showOptions">
          <advice color="primary">
            {{ $t('teletag.getTeletag.advice.numberTags') }}
          </advice>

          <v-layout row wrap justify-space-between class="mt-4">
            <v-flex xs12 sm5>
              <v-btn
                color="primary"
                outline
                class="initialize white--text"
                block
                :to="{ path: $t('urlPrescriptor'), query: { back: true } }"
                round
              >
                {{ $t('teletag.getTeletag.button.shop') }}
              </v-btn>
            </v-flex>
            <v-flex xs12 sm5>
              <v-btn
                v-if="showRequestLetter"
                color="accent right"
                outline
                class="initialize white--text"
                block
                @click="showOptions = !showOptions"
                round
              >
                {{ $t('teletag.getTeletag.button.letter') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </template>

        <request-letter-form
          v-if="!showOptions"
          @on-close="closeRequestLetterForm"
        ></request-letter-form>
      </v-container>
    </v-card>
  </wsp-modal>
</template>

<script>
import WspModal from '@/components/commons/WspModal';
import RequestLetterForm from '@/components/private/tag/RequestLetterForm';
import Advice from '@/components/commons/Advice';
import utilService from '@/services/utilService';

export default {
  name: 'ChooseOptionGetTeletag',
  components: {
    [RequestLetterForm.name]: RequestLetterForm,
    [Advice.name]: Advice,
    [WspModal.name]: WspModal,
  },
  computed: {
    fullWidth() {
      return this.$vuetify.breakpoint.xs;
    },
  },
  watch: {
    visible: function (value) {
      if (!value) {
        this.$emit('on-close', {});
      }
    },
  },
  data() {
    return {
      showOptions: true,
      showRequestLetter: !utilService.isChile(),
      visible: true,
    };
  },
  created() {},
  methods: {
    closeRequestLetterForm() {
      // this.showOptions = false
      this.visible = false;
    },
  },
};
</script>
